import { defaultTo } from "lodash";
import { DateTime } from "luxon";
import { IModel, Model, ModelRecord } from "./Model";

export interface IMacroListingModel extends IModel {
    macroId: number;
    name: string;
    content: string;
    userId: number;
    hospitalId: number;
    macroTypeId: number;
    macroTypeName: string;
    macroTypeRowVersion: string;
    assignedTo: string;
    createdBy: string;
    dateCreated: string;
    isActive: boolean;
    macroTargetTypeId?: number | undefined;
}
export class MacroListingModel extends Model implements ModelRecord<IMacroListingModel> {
    macroId: number;
    name: string;
    content: string;
    userId: number;
    hospitalId: number;
    macroTypeId: number;
    macroTypeName: string;
    macroTypeRowVersion: string;
    assignedTo: string;
    createdBy: string;
    dateCreated: DateTime;
    isActive: boolean;
    macroTargetTypeId: number | undefined;

    constructor(params: Partial<IMacroListingModel>) {
        super(params);
        this.macroId = defaultTo(params.macroId, 0);
        this.name = defaultTo(params.name, "");
        this.content = defaultTo(params.content, "");
        this.userId = defaultTo(params.userId, 0);
        this.hospitalId = defaultTo(params.hospitalId, 0);
        this.macroTypeId = defaultTo(params.macroTypeId, 0);
        this.macroTypeName = defaultTo(params.macroTypeName, "");
        this.macroTypeRowVersion = defaultTo(params.macroTypeRowVersion, "");
        this.assignedTo = defaultTo(params.assignedTo, "");
        this.createdBy = defaultTo(params.createdBy, "");
        this.dateCreated = DateTime.fromISO(defaultTo(params.dateCreated, "2000-01-01"), { zone: "utc" });
        this.isActive = defaultTo(params.isActive, true);
        this.macroTargetTypeId = defaultTo(params.macroTargetTypeId, 1);
    }
}
